import TranslatedHtml from "@components/common/TranslatedHtml"
import { addNamespacePrefixIfNotPresent } from "@services/i18n"
import { flattenErrors, INestedErrorList } from "@services/submissionError"

interface IProps {
  errors: { [key: string]: any }
  excludeFields?: string[]
  prefix?: string
  suffixForErrorTitle?: string
}
/**
 * shows a list of errors, e.g. to show errors coming from the backend
 * of which some may be excluded to be handled differently
 */
const GeneralFormError: React.FC<IProps> = ({ errors, excludeFields = [], prefix = "", suffixForErrorTitle = "" }: IProps) => {
  const generalErrors: JSX.Element[] = []
  Object.keys(errors).forEach((key) => {

    // these fields show their own errors, no need to show them here
    if (excludeFields.includes(key)) {
      return
    }

    if (typeof errors[key] === "string") {
      const parts = (errors[key] as string).split("\n")
      parts.forEach(part => generalErrors.push(<TranslatedHtml content={addNamespacePrefixIfNotPresent("error", part)} />))
    }
    else if (!errors[key]) {
      return
    }

    // we may receive nested errors here, e.g. for forms that submit JSON elements ->
    // flatten the errors and display the propertyPath in front of the error:
    else {
      const elementErrors = flattenErrors(errors[key] as INestedErrorList, prefix ? prefix + "." + key : key)
      Object.keys(elementErrors).forEach((k) => {
        generalErrors.push(<>
          <TranslatedHtml content={k + (suffixForErrorTitle ? "." + suffixForErrorTitle : "")} />
          : <TranslatedHtml content={addNamespacePrefixIfNotPresent("error", elementErrors[k])} />
        </>)
      })
    }
  })

  if (generalErrors.length === 0) {
    return null
  }

  return <div className="form-general-error-container">
    {generalErrors.map((err, index) =>
      <div
        className="form-general-error"
        key={index}
        id="form-general-error"
      >
        {err}
      </div>
    )}
  </div>
}

export default GeneralFormError
